import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { ApiDocsConfig } from '@backstage/plugin-api-docs';
import { defaultDefinitionWidgets } from '@backstage/plugin-api-docs';
import { apiDocsConfigRef } from '@backstage/plugin-api-docs';
import { openRpcWidgetConfig } from '@internal/backstage-plugin-open-rpc-viewer-react';


const customApiDocsConfig: ApiDocsConfig = {
  getApiDefinitionWidget: apiEntity => {
    const widgets = defaultDefinitionWidgets();
    widgets.push(openRpcWidgetConfig);
    return widgets.find(w => w.type === apiEntity.spec?.type);
  },
};

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => customApiDocsConfig,
  }),
  ScmAuth.createDefaultApiFactory(),
];
